module.exports = __webpack_public_path__ + "static/img/tejh.9e5b1d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/enjoyImg/tejh.png
// module id = wIi6
// module chunks = 119